import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import { useVote } from './hooks/useVote';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import { useMediaLoader } from './hooks/useMediaLoader';

import Advt from './components/Advt/Advt';
import { MessagesList } from './components/MessagesList/MessagesList';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import present from './assets/images/present.png';

function App() {
  const { voteState, currentState, voteActivity: isVisible } = useVote();
  const { showedMessages, winnerMessage, speed } = useCarousel();

  const { authorFontSize, bgVideo, bgPoster } = useGetParams();

  const prize = useMemo(() => {
    const isCorrect = voteState?.vars.find((v) => v.correct)?.varImgUrl;

    return isCorrect ? isCorrect : present;
  }, [voteState]);

  const { isFullyLoaded } = useMediaLoader(prize, 'image');

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            style={{ width: '100%', height: '100%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            key="advt"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}

        {['S2', 'S3', 'S4'].includes(currentState) && (
          <motion.div
            style={{ width: '100%', height: '100%' }}
            key="msgs"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: '0' }}
            transition={{ duration: 0.5 }}
          >
            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              currentState={currentState}
              speed={speed || 0}
            />
            {voteState && isFullyLoaded && (
              <SwitchTransition>
                <CSSTransition
                  appear={true}
                  key={prize}
                  addEndListener={(node, done) =>
                    node.addEventListener('transitionend', done, false)
                  }
                  classNames="fade"
                >
                  <div className="present">
                    <img src={prize} alt="prize" className="presentImg" />
                  </div>
                </CSSTransition>
              </SwitchTransition>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          />
        </video>
      )}
    </div>
  );
}

export default App;
